import { useEffect, useState } from "react"
import { useIntl } from "react-intl"
import { InfoCard2 } from "../../../widgets/components/UI/InfoCard2"
import { Dropdown, Pagination, Table } from "react-bootstrap"
import threeDots from '../../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import IconDrag from '../../../../../media/images/drag.svg'
import { DisplayImage } from "../../../widgets/components/General/DisplayImage"
import AddAgenda from "./AddAgenda"
import { deleteAgenda, getAgenda, getMeetings, getParticipants, reorderAgenda } from "../../core/_requests"
import { toast } from "react-toastify"
import { RankingInfo, rankItem } from '@tanstack/match-sorter-utils'
import {
  ColumnDef,
  ColumnFiltersState,
  FilterFn,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'
import React from "react"
import { differenceTime, getFileType } from "../../core/_util"
import NoDataPage from "../../../widgets/components/NoDataPage"
import SkeletonRow from "../../../digital-signing/components/SkeletonRow"
import { DeleteAgendaConfirmationModal } from "../CancelConfimrationModal"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import { GTMEvent } from "../../../../hooks/gtmHelpers"
import TagManager from "react-gtm-module"
import { useAuth } from "../../../auth"
import searchIcon from '../../../../../_metronic/assets/images/svg/data-room/search-icon-grey.svg'
import brandingConfig from "../../../../../config/brandingConfig"

export default function Agenda({ setSidebar, meetingId, meetingType }: any) {
  const { formatMessage } = useIntl()
  const { currentUser, companyId } = useAuth()
  const [agendaData, setAgendaData] = useState<any>([])
  const [editData, setEditData] = useState('')
  const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
    const itemRank = rankItem(row.getValue(columnId), value)
    addMeta({ itemRank })
    return itemRank.passed
  }
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([])
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>()
  const [globalFilter, setGlobalFilter] = useState('')
  const [isActive, setIsActive] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [cancelLoading, setCancelLoading] = useState(false)
  const [id, setId] = useState('')
  const [loading1, setLoading1] = useState(false)
  const [pagination, setPagination] = useState<{
    currentPage: number
    pageSize: number
    totalCount: number
    nextPage: number
    prevPage: number | null
    totalPages: number
  }>({
    currentPage: 1,
    pageSize: 10,
    totalCount: 0,
    nextPage: 0,
    prevPage: null,
    totalPages: 0,
  })
  const multiFieldGlobalFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
    // Check if the search term is in the email or the combined name fields
    const agendaMatch = rankItem(row.original.agendaTitle, value)
    const presenterMatch = rankItem(`${row.original.presenter} `, value)

    // Determine which match to use based on rank comparison or other logic
    let bestMatch: RankingInfo | undefined
    if (agendaMatch.passed && presenterMatch.passed) {
      bestMatch = agendaMatch.rank < presenterMatch.rank ? agendaMatch : presenterMatch
    } else if (agendaMatch.passed) {
      bestMatch = agendaMatch
    } else if (presenterMatch.passed) {
      bestMatch = presenterMatch
    }

    // Only call addMeta if a best match is found
    if (bestMatch) {
      addMeta({ itemRank: bestMatch })
    }

    // Return whether the search term passed in either field
    return !!bestMatch
  }
  const [leftTime, setLeftTime] = useState(0)
  const getMeetingDetails = async () => {
    setLoading1(true)
    try {
      const {
        data: { success, data },
      } = await getMeetings(meetingId);

      if (success) {
        try {

          const {
            data: { success: agendaSuccess, data: agendaData },
          } = await getAgenda(meetingId, true);

          if (agendaSuccess) {
            const timesList = agendaData.data.map((item: any) =>
              parseInt(item.assignedTime.split(' ')[0], 10)
            );
            const totalTimeLeft = timesList.reduce((acc: any, time: any) => acc + time, 0);
            const leftSlotTime = differenceTime(data.meetingDate, data.startTime, data.endTime);
            setLeftTime(leftSlotTime - totalTimeLeft);
          }
        } catch (err) {
          console.log("Error fetching agenda:", err);
        }
      }
    } catch (err) {
      console.log("Error fetching meeting details:", err);
    }
    finally {
      setLoading1(false)
    }
  };

  const columns = React.useMemo<ColumnDef<any, any>[]>(
    () => [
      {
        accessorKey: 'agendaTitle',
        id: 'Agenda',
        header: 'Agenda',
        cell: (info) => {
          const { agendaTitle } = info.row.original; // Destructured for readability
          return (
            <div className='d-flex align-items-center gap-2'>
              <img src={IconDrag} alt='Drag sequence icon' width={32} height={32} />
              <p className='mb-0 font-size-13'>{agendaTitle}</p>
            </div>
          );
        },
        filterFn: 'includesString',
      },
      {
        accessorKey: 'presenter',
        id: 'Presenters',
        header: 'Presenters',
        cell: (info) => {
          const { presenter } = info.row.original;
          return <div className='px-3'>{presenter ?
            <div className='d-flex align-items-center gap-2'>
              <DisplayImage
                imgName={'dummy'}
                alt='profile'
                fit='cover'
                className='rounded-circle'
                width={32}
                height={32}
              />
              <p className='mb-0 font-size-13'>{presenter}</p>
            </div>
            : <p className='mb-0 font-size-13'>{'-'}</p>}</div>;
        },
        filterFn: 'includesString',
      },
      {
        accessorKey: 'assignedTime',
        id: 'Assigned time',
        header: 'Assigned time',
        cell: (info) => {
          const { assignedTime } = info.row.original;
          return <div className="mt-2">{assignedTime.split(' ')[0]} mins</div>
        },
        filterFn: 'includesString',
      },
      {
        accessorKey: 'type',
        id: 'Attachments',
        header: 'Attachments',
        cell: (info) => {
          const { AgendaDocuments } = info.row.original;
          return (
            <div className='d-flex align-items-center'>
              {AgendaDocuments.length > 0 ? AgendaDocuments.slice(0, AgendaDocuments.length > 3 ? 3 : AgendaDocuments.length).map((doc: any) => (
                <img
                  key={doc.documentsId}
                  src={getFileType(doc.file.name)} // Assuming getFileType returns the icon path
                  alt='Document icon'
                  width={32}
                  height={32}
                />
              )) : "No Files"
              }
              {
                AgendaDocuments?.length > 3 && (
                  <span className='ms-2'>
                    {`& ${AgendaDocuments?.length - 3 === 1 ? '1 more file' : `${AgendaDocuments?.length - 3} more files`}`}
                  </span>
                )
              }
            </div>
          );
        },
        filterFn: 'includesString',
      },
      {
        id: 'actions',
        header: 'Actions',
        cell: ({ row }) => {
          return (
            <div className='dropdown-container d-flex justify-content-center'>
              <Dropdown
                show={row.index === selectedIndex}
                onToggle={(isOpen, event: any) => {
                  if (event.source === 'click') {
                    setSelectedIndex(isOpen ? row.index : undefined)
                  } else {
                    setSelectedIndex(undefined)
                  }
                }}
              >
                <Dropdown.Toggle className='btn btn-white table-three-dots dots-container '>
                  <img src={threeDots} alt='' className='three-dots-image' />
                </Dropdown.Toggle>
                <Dropdown.Menu className='m-2'>
                  <Dropdown.Item
                    className='text-dark ps-5' onClick={() => { updateAgenda(row.original) }}>
                    {formatMessage({ id: 'Edit Agenda' })}
                  </Dropdown.Item>
                  <Dropdown.Item
                    className='text-danger ps-5' onClick={() => {
                      setShowCancelModal(true)
                      setId(row.original.agendaId)
                    }}>
                    <p className='mb-0'>{formatMessage({ id: 'Remove Agenda' })}</p>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        },
      },
    ],
    [selectedIndex]// eslint-disable-line react-hooks/exhaustive-deps
  );
  const table = useReactTable({
    data: agendaData,
    columns,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    manualPagination: true,
    rowCount: pagination.totalCount,
    state: {
      columnFilters,
      globalFilter,
    },
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: multiFieldGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  })
  const getMeetingAgenda = async () => {
    try {
      setLoading(true)
      const {
        data: { success, data },
      } = await getAgenda(meetingId, false, pagination.currentPage,
        pagination.pageSize)
      if (success) {
        setPagination((prev) => ({
          ...prev,
          currentPage: data.pagination?.currentPage,
          pageSize: data.pagination?.pageSize,
          totalCount: data.pagination?.totalRecords,
          nextPage: data.pagination?.nextPage,
          prevPage: data.pagination?.prevPage,
          totalPages: data.pagination?.totalPages,
        }))
        setAgendaData(data.data)
      }
    } catch (err) {
      console.log(err)
    } finally { setLoading(false) }
  }
  const removeAgenda = async () => {
    setCancelLoading(true)
    try {
      const {
        data: { success, error },
      } = await deleteAgenda(id)
      if (success) {
        getMeetingAgenda()
        toast.success(formatMessage({ id: 'Meeting agenda removed successfully.' }))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.AgendaDeletedSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              agenda_id: id
            },
          },
        })
      }
      else {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.AgendaDeleteFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              agenda_id: id,
              error: error[0]
            },
          },
        })
      }
    } catch (err) {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.AgendaDeleteFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            agenda_id: id,
            error: err
          },
        },
      })
    }
    finally {
      setCancelLoading(false)
      setShowCancelModal(false)

    }
  }
  const updateAgenda = async (details: any) => {
    try {
      setIsActive(true)
      setEditData(details)
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    if (meetingId)
      getMeetingAgenda()
  }, [pagination.currentPage, pagination.pageSize, isActive])// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!isActive)
      setEditData('')
  }, [isActive])// eslint-disable-line react-hooks/exhaustive-deps

  const handlePageChange = (pageNumber: number) => {
    setPagination((prev) => ({ ...prev, currentPage: pageNumber }))
  }
  useEffect(() => {
    if (meetingId)
      getMeetingDetails()
  }, [meetingId, isActive])// eslint-disable-line react-hooks/exhaustive-deps
  const updatePosition = async (agendaId: string, position: number) => {
    try {
      const {
        data: { success },
      } = await reorderAgenda(meetingId, agendaId, position)
      if (success) {
        toast.success(formatMessage({ id: 'Meeting agenda position updated successfully.' }))
      }
    }
    catch (e) {
      console.log(e)
    }
  }
  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;
    const reorderedData = Array.from(agendaData);
    const [removed] = reorderedData.splice(result.source.index, 1);
    reorderedData.splice(result.destination.index, 0, removed);
    updatePosition(result.draggableId, result.destination.index)
    setAgendaData(reorderedData);
  };
  const [userList, setUserList] = useState([])
  useEffect(() => {
    const getMeetingParticipant = async () => {
      try {
        const {
          data: { success, data },
        } = await getParticipants(meetingId, true)
        if (success) {
          setUserList(data.data.map((item: any, index: number) => { return { label: item.name, value: item.name, id: index } }))
        }
      } catch (err) {
        console.log(err)
      }
    }
    getMeetingParticipant()
  }, [])// eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <div className='d-md-flex justify-content-between align-items-center'>
        <p className='mb-4 mb-md-0'>{formatMessage({ id: 'Agenda' })}</p>
        <div className="d-md-flex align-items-center gap-2">
          {/* Search form */}
          <form className='align-items-center d-flex w-100 border rounded mb-md-0 mb-2 position-relative'>
            <span className='svg-icon svg-icon-3 position-absolute ms-2'>
              <img src={searchIcon} alt='Search icon' />
            </span>
            <DebouncedInput
              value={globalFilter ?? ''}
              onChange={(value) => setGlobalFilter(String(value))}
              className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-md-12 font-size-13 font-weight-400 height-36'
              style={{ width: 'auto !important' }}
              placeholder='Search by Agenda or presenters'
            />
          </form>
          {/* Add Agenda button */}
          <div className='w-100'>
            <button
              id='dropdown-custom-components'
              className='btn bg-primary custom-button-property text-white justify-content-center text-mute font-weight-400 font-size-13 height-36 d-flex align-items-center w-100'
              onClick={() => {
                if (!meetingId) toast.error('Please complete the schedule section.')
                else if (meetingId && leftTime > 0) setIsActive(true)
                else if (leftTime === 0)
                  toast.error('The selected time slot for the meeting is fully booked.')
                else
                  toast.error(
                    'The total agenda duration exceeds the meeting duration. Please either reduce the agenda item times or extend the meeting duration.'
                  )
              }}
              disabled={loading1}
            >
              {formatMessage({ id: 'Add Agenda' })}
            </button>
          </div>
        </div>
      </div>

      <div className='mt-5 mb-9 w-100'>
        {meetingType === 'Virtual Meeting' ? (
          <InfoCard2
            title={formatMessage({ id: 'How to Schedule Virtual Compliance Meetings?' })}
            desc={formatMessage({
              id: `Schedule virtual compliance meetings with board members and stakeholders on ${brandingConfig.brandName} by adding scheduling details, managing participants, setting the agenda, and reviewing the details. This feature ensures organized and efficient compliance management.`,
            })}
            slug={brandingConfig.helpLinks.complianceMeetingScheduleNewMeetingVirtual}
          />
        ) : (
          <InfoCard2
            title={formatMessage({ id: 'How to Schedule Physical Compliance Meetings?' })}
            desc={formatMessage({
              id: `Schedule physical compliance meetings with board members and stakeholders on ${brandingConfig.brandName} by adding venue and scheduling details, inviting attendees, setting the agenda, and reviewing the details. This feature ensures organized and efficient compliance management.`,
            })}
            slug={brandingConfig.helpLinks.complianceMeetingScheduleNewMeetingPhysical}
          />
        )}
        <div className='bg-white rounded-2 p-4'>
          {!loading && (agendaData?.length === 0 || table.getRowModel().rows.length === 0) ? (
            <div className='my-5 mx-6'>
              <NoDataPage width={'w-0'} />
            </div>
          ) : (
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId='droppable'>
                {(provided) => (
                  <Table className='w-100' {...provided.droppableProps} ref={provided.innerRef}>
                    <thead className='custom-thead border-bottom'>
                      {table.getHeaderGroups().map((headerGroup) => (
                        <tr
                          key={headerGroup.id}
                          className='font-size-12 font-weight-400 w-100 table-row border-dark-mode'
                        >
                          {headerGroup.headers.map((header) => (
                            <th key={header.id} colSpan={header.colSpan} className='pb-6 pt-4'>
                              {header.isPlaceholder ? null : (
                                <div
                                  className={
                                    header.column.getCanSort() ? 'cursor-pointer select-none' : ''
                                  }
                                  onClick={header.column.getToggleSortingHandler()}
                                >
                                  {flexRender(
                                    header.column.columnDef.header,
                                    header.getContext()
                                  )}
                                  {{
                                    asc: ' ▲',
                                    desc: ' ▼',
                                  }[header.column.getIsSorted() as string] ?? null}
                                </div>
                              )}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody>
                      {loading ? (
                        <>
                          <SkeletonRow count={8} />
                        </>
                      ) : (
                        table.getRowModel().rows.map((row, index) => (
                          <Draggable
                            key={row.original.agendaId}
                            draggableId={row.original.agendaId}
                            index={index}
                          >
                            {(provided) => (
                              <tr
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                className='border-bottom'
                              >
                                {row.getVisibleCells().map((cell) => (
                                  <td key={cell.id} className='pt-4 border-0'>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                  </td>
                                ))}
                              </tr>
                            )}
                          </Draggable>
                        ))
                      )}
                    </tbody>
                  </Table>
                )}
              </Droppable>
            </DragDropContext>
          )}
          {!loading && agendaData?.length > 0 && (
            <div className='w-100 d-md-flex justify-content-between align-items-center px-0 mt-8'>
              <div className='d-flex gap-2 w-100 align-items-center justify-content-md-start justify-content-center mb-4'>
                <select
                  aria-label='Default select example'
                  className='p-4 py-3 w-80px border border-1 rounded-2 font-size-13'
                  value={pagination.pageSize}
                  onChange={(e) => {
                    const newSize = Number(e.target.value)
                    setPagination((prev) => ({
                      ...prev,
                      pageSize: newSize,
                      pageIndex: 0, // Reset to first page when page size changes
                    }))
                  }}
                >
                  {[10, 20, 50, 100].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      {pageSize}
                    </option>
                  ))}
                </select>

                <span className='font-size-13 text-center text-md-start'>
                  {formatMessage({
                    id: `Showing ${pagination.currentPage === 1
                      ? 1
                      : (pagination.currentPage - 1) * pagination.pageSize + 1
                      } to ${pagination.totalCount > pagination.currentPage * pagination.pageSize
                        ? pagination.currentPage * pagination.pageSize
                        : pagination.totalCount -
                        pagination.currentPage * pagination.pageSize +
                        pagination.currentPage * pagination.pageSize
                      } of ${pagination.totalCount} records`,
                  })}
                </span>
              </div>

              <Pagination className='w-md-100 w-auto d-flex flex-md-end justify-content-center justify-content-md-end '>
                <Pagination.First
                  onClick={() => handlePageChange(1)}
                  disabled={!pagination.prevPage}
                >
                  {'<<'}
                </Pagination.First>

                <Pagination.Prev
                  onClick={() => handlePageChange(pagination.currentPage - 1)}
                  disabled={!pagination.prevPage}
                >
                  {'<'}
                </Pagination.Prev>

                {Array.from({ length: pagination.totalPages }, (_, i) => (
                  <Pagination.Item
                    key={i}
                    active={i === pagination.currentPage - 1}
                    onClick={() => handlePageChange(i + 1)}
                  >
                    {i + 1}
                  </Pagination.Item>
                ))}

                <Pagination.Next
                  onClick={() => handlePageChange(pagination.currentPage + 1)}
                  disabled={!pagination.nextPage}
                >
                  {'>'}
                </Pagination.Next>

                <Pagination.Last
                  onClick={() => handlePageChange(pagination.totalPages)}
                  disabled={!pagination.nextPage}
                >
                  {'>>'}
                </Pagination.Last>
              </Pagination>
            </div>
          )}
        </div>
        {isActive && (
          <AddAgenda
            isActive={isActive}
            setIsActive={setIsActive}
            meetingId={meetingId}
            editData={editData}
            meetingType={meetingType}
            leftTime={leftTime}
            userList={userList}
          />
        )}
      </div>
      <div className='d-flex flex-md-row flex-column gap-3 justify-content-end mt-4'>
        <button
          className='btn bg-light custom-button-property text-muted fw-normal py-4 w-100 w-md-auto order-md-1 order-2'
          style={{ width: '120px' }}
          type='button'
          onClick={() => {
            setSidebar(3)
          }}
        >
          <span className='indicator-label font-size-13 p-0'>
            {formatMessage({ id: 'Prev' })}
          </span>
        </button>

        <button
          className='btn bg-primary custom-button-property text-white fw-normal py-4 w-100 w-md-auto order-md-2 order-1'
          style={{ width: '120px' }}
          disabled={agendaData.length === 0}
          onClick={() => {
            if (leftTime < 0)
              toast.error(
                'The total agenda duration exceeds the meeting duration. Please either reduce the agenda item times or extend the meeting duration.'
              )
            else setSidebar(5)
          }}
        >
          <span className='indicator-label font-size-13 p-0'>
            {formatMessage({ id: 'Next' })}
          </span>
        </button>
      </div>
      <DeleteAgendaConfirmationModal
        setDeleteShowModal={setShowCancelModal}
        showDeleteModal={showCancelModal}
        onDeleteSubmit={removeAgenda}
        deleteLoading={cancelLoading}
      />
    </>
  )
}

function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number
  onChange: (value: string | number) => void
  debounce?: number
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value)
    }, debounce)

    return () => clearTimeout(timeout)
  }, [value, debounce, onChange])
  return <input {...props} value={value} onChange={(e) => setValue(e.target.value)} />
}